/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails are copyrighted by their creators. Downloading for personal reference is generally fine, but reusing one publicly may need the owner's permission.`)
};

const es_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las miniaturas tienen derechos de autor de sus creadores. Descargarlas para referencia personal suele estar bien, pero reutilizar una públicamente puede requerir el permiso del propietario.`)
};

const de_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails sind urheberrechtlich geschützt und gehören ihren Erstellern. Der Download zur privaten Nutzung ist in der Regel unbedenklich, für die öffentliche Weiterverwendung ist meist die Erlaubnis des Eigentümers nötig.`)
};

const nl_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails zijn auteursrechtelijk beschermd door hun makers. Downloaden voor persoonlijk gebruik is over het algemeen prima, maar voor openbaar hergebruik heb je mogelijk toestemming van de eigenaar nodig.`)
};

const fr_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les miniatures sont protégées par le droit d’auteur de leurs créateurs. Les télécharger pour un usage personnel est généralement sans problème, mais les réutiliser publiquement peut nécessiter l’autorisation du propriétaire.`)
};

const it_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le miniature sono protette da copyright dei loro creatori. Scaricarle per uso personale è generalmente accettabile, ma riutilizzarle pubblicamente potrebbe richiedere il permesso del proprietario.`)
};

const pt_br2_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As thumbnails têm direitos autorais dos criadores. Baixar para referência pessoal geralmente é aceitável, mas reutilizá-las publicamente pode exigir a permissão do proprietário.`)
};

const pt_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As miniaturas têm direitos de autor dos seus criadores. Descarregar para referência pessoal é geralmente aceitável, mas reutilizar uma publicamente pode exigir a permissão do proprietário.`)
};

const ja_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サムネイルはその制作者に著作権があります。個人的な参考のためにダウンロードするのは基本的に問題ありませんが、公開の場で再利用する場合は権利者の許可が必要になることがあります。`)
};

const zh_yt_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩略图受创作者版权保护。出于个人参考目的下载通常没有问题，但公开重复使用可能需要获得所有者的许可。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hub_faq3_a", locale)
	if (locale === "en") return en_yt_hub_faq3_a(inputs)
	if (locale === "es") return es_yt_hub_faq3_a(inputs)
	if (locale === "de") return de_yt_hub_faq3_a(inputs)
	if (locale === "nl") return nl_yt_hub_faq3_a(inputs)
	if (locale === "fr") return fr_yt_hub_faq3_a(inputs)
	if (locale === "it") return it_yt_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hub_faq3_a(inputs)
	if (locale === "pt") return pt_yt_hub_faq3_a(inputs)
	if (locale === "ja") return ja_yt_hub_faq3_a(inputs)
	return zh_yt_hub_faq3_a(inputs)
};